var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',{staticClass:"mb-2 text-center"},[_vm._v(" "+_vm._s(_vm.$gettextInterpolate(_vm.$gettext('Apps for your search: "%{searchTerm}"'), {searchTerm: _vm.searchTerm}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }